// Import api models.
import {
	ComparisonSummaryPerilDeductible,
} from '@app/models/api';

interface ComparisonSummaryPerilsDeductiblesParameters {
	allowEdits: boolean;
	requiresReview: boolean;
	comparisonPerilDeductibleSummaries: ComparisonSummaryPerilDeductible[];
}

export default class ComparisonSummaryPerilsDeductibles {

	public allowEdits: boolean;
	public requiresReview: boolean;
	public comparisonPerilDeductibleSummaries: ComparisonSummaryPerilDeductible[];

	public constructor(params: ComparisonSummaryPerilsDeductiblesParameters) {
		this.allowEdits = params.allowEdits;
		this.requiresReview = params.requiresReview;
		this.comparisonPerilDeductibleSummaries = params.comparisonPerilDeductibleSummaries;
	}
}